import { rotateImagePreview, selectImagePreviewRotation, useAppDispatch, useAppSelector } from '@/store';

/** An image preview's clockwise turn, kept for the chat session, and steps of 90° either way. */
export function useImagePreviewRotation(documentId: string) {
  const dispatch = useAppDispatch();
  const rotation = useAppSelector((state) => selectImagePreviewRotation(state, documentId));
  const rotateClockwise = () => dispatch(rotateImagePreview({ documentId }));
  const rotateAnticlockwise = () => dispatch(rotateImagePreview({ documentId, anticlockwise: true }));

  return { rotation, rotateClockwise, rotateAnticlockwise };
}
